import { memo, useMemo, useRef } from 'react';
import useWeather from '../../hooks/useWeather.js';
import NavDay from '../NavDay/index.jsx';
import type { INavRecord } from '../../interface.js';
import { useMemoizedFn } from 'ahooks';
import isEqual from 'react-fast-compare';
import dayjs, { type Dayjs } from 'dayjs';

const weekNoArr = ['第一周', '第二周', '第三周', '第四周', '第五周', '第六周'];

function NavList({
  value,
  onChange,
  startTime,
  endTime,
  location,
  display,
  planId,
  size,
}: {
  planId?: string;
  value: string;
  onChange: (payload: string) => void;
  startTime: Dayjs;
  endTime: Dayjs;
  location?: Array<{
    name: string;
    city: string;
    startTime: string;
    endTime: string;
  }>;
  size?: string;
  display?: string;
}) {
  const dayList: INavRecord[] = useMemo(() => {
    const diffDay = endTime.diff(startTime, 'day') + 1;
    let weekNoIdx = 1;
    return [...new Array(diffDay)].map((item, index, array) => {
      const date = startTime.add(index, 'day');
      const dateText = date.format('YYYY-MM-DD');
      // const label = `${date.format('MM.DD')} ${getWeekdays(date.day())}`;
      let weekNo = '';
      if (date.day() === 0) {
        weekNo = weekNoArr[weekNoIdx];
        weekNoIdx += 1;
      }
      const locationInfo = location?.findLast((item) => {
        return date.isBetween?.(item.startTime, item.endTime, 'day', '[]');
      });
      return {
        // label,
        weekNo,
        date: dateText,
        location: locationInfo?.name,
        city: locationInfo?.city,
      };
    });
  }, [startTime, endTime, location]);

  // STEP: 获取天气
  const {
    weather,
    setWeather,
    placeholder: weatherPlaceholder,
  } = useWeather({ planId });

  const navList = useMemo<INavRecord[]>(() => {
    return [
      { date: '总览' },
      ...dayList.map((i) => {
        return {
          ...i,
          weather: i.city
            ? i.date
              ? weather[i.date]?.[i.city]
              : ''
            : weather[i.date]?.default,
        };
      }),
    ];
  }, [weather, dayList]);

  const actions = useMemo(() => {
    return {
      setWeather,
    };
  }, [setWeather]);
  const ref = useRef<null | HTMLDivElement>(null);
  const onScrollTo = useMemoizedFn(({ left }: { left: number }) => {
    ref.current?.scrollTo({ left, behavior: 'smooth' });
  });

  const isSmall = size === 'sm';

  return (
    <>
      <section
        className={'sticky z-10  bg-inherit'}
        style={{
          top: 'calc(env(safe-area-inset-top) + 50px)',
        }}
      >
        <div
          className=' rounded-t-[30px] bg-white pt-2 pb-2 px-5 overflow-auto flex items-center pr-10 no-scrollbar'
          ref={ref}
        >
          {/* <div className="flex w-max pr-10 items-center scale-90 origin-left  "> */}
          {navList.map((item, index, array) => {
            const checked = item.date === value;
            const startPosition =
              index > 1 && item.location !== array[index - 1]?.location
                ? item.location
                : '';

            return (
              <NavDay
                key={item.date}
                record={item}
                checked={checked}
                index={index}
                startPosition={startPosition}
                onClick={() => {
                  onChange(item.date);
                }}
                actions={actions}
                onScrollTo={onScrollTo}
                planId={planId}
                size={size}
                display={display}
              />
            );
          })}
          {/* </div> */}
        </div>
        <span className=' absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-white to-white/0 pointer-events-none rounded-tr-[30px]' />
      </section>
      {weatherPlaceholder}
    </>
  );
}

export default memo(NavList, isEqual);
